export const getLineTextCoords = ({ x1, y1 }: { x1: number; y1: number }, { x2, y2 }: { x2: number; y2: number }) => {
  const minY = Math.max(y1, y2);

  if (y1 === minY) return { textX: x1, textY: y1 };
  return { textX: x2, textY: y2 };
};
